<div class="save-button-container">
    <button
        mat-raised-button
        color="primary"
        [disabled]="disable()"
        (click)="saveEvent.emit(SAVE_BUTTON_ACTIONS.Save)"
        class="save-btn"
        [class.single-btn]="type() === SAVE_BUTTON_TYPE.OnlySave"
        data-testid="save-button-action-save">
        {{ saveLabel() | translate }}
    </button>
    @if (type() !== SAVE_BUTTON_TYPE.OnlySave) {
        <button
            mat-raised-button
            color="primary"
            [disabled]="disable()"
            [matMenuTriggerFor]="menu"
            class="menu-btn"
            data-testid="save-button-trigger-other-actions">
            <mat-icon class="material-symbols-outlined">keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu #menu="matMenu" xPosition="before" class="cipo">
            @if (type() === SAVE_BUTTON_TYPE.SaveAndClose || type() === SAVE_BUTTON_TYPE.AllOptions) {
                <button
                    mat-menu-item
                    (click)="saveEvent.emit(SAVE_BUTTON_ACTIONS.SaveAndClose)"
                    data-testid="save-button-action-save-and-close">
                    <mat-icon class="material-symbols-outlined">save</mat-icon>
                    <span>{{ "general.saveAndClose" | translate }}</span>
                </button>
            }
            @if (type() === SAVE_BUTTON_TYPE.SaveAndAddNew || type() === SAVE_BUTTON_TYPE.AllOptions) {
                <button
                    mat-menu-item
                    (click)="saveEvent.emit(SAVE_BUTTON_ACTIONS.SaveAndAddNew)"
                    data-testid="save-button-action-save-and-new">
                    <mat-icon class="material-symbols-outlined">note_stack_add</mat-icon>
                    <span>{{ "general.saveAndNew" | translate }}</span>
                </button>
            }
            @for (item of customActions(); track item.id) {
                @if (item.id === DropdownActionsEnum.DIVIDER) {
                    <div class="cipo--border-bottom--lite m-x-sm"></div>
                } @else {
                    <button
                        mat-menu-item
                        (click)="!item.submenu?.length && actionClicked(item.id)"
                        [matMenuTriggerFor]="item.submenu?.length ? subMenu : null"
                        [matMenuTriggerData]="{ subMenuItems: item.submenu, parentActionId: item.id }"
                        [attr.data-testid]="'save-button-action-' + item.label">
                        @if (item.icon) {
                            <mat-icon class="material-symbols-outlined">{{ item.icon }}</mat-icon>
                        }
                        <span>{{ item.label | translate }}</span>
                    </button>
                }
            }
        </mat-menu>
    }
</div>

<mat-menu #subMenu="matMenu">
    <ng-template matMenuContent let-subMenuItems="subMenuItems" let-parentActionId="parentActionId">
        @for (item of subMenuItems; track $index) {
            <button mat-menu-item (click)="actionClicked(parentActionId, item)">{{ item.label }}</button>
        }
    </ng-template>
</mat-menu>
